/** Anzeigeformate. Betraege kommen ueberall als ganzzahlige Cent herein. */

const EUR = new Intl.NumberFormat("de-DE", {
  style: "currency", currency: "EUR", maximumFractionDigits: 0, minimumFractionDigits: 0,
});
const EUR_SIGNED = new Intl.NumberFormat("de-DE", {
  style: "currency", currency: "EUR", maximumFractionDigits: 0, minimumFractionDigits: 0, signDisplay: "always",
});
const EUR_EXACT = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

/** Ohne die Klemmung zeigt eine Achse bei Rundungsresten "-0 €". */
const clamp = (cents: number): number => (Math.abs(cents) < 50 ? 0 : cents);

export const euro = (cents: number): string => EUR.format(clamp(cents) / 100);
export const euroSigned = (cents: number): string => EUR_SIGNED.format(clamp(cents) / 100);
export const euroExact = (cents: number): string => EUR_EXACT.format(cents / 100);

export function dayMonth(iso: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("de-DE", {
    day: "2-digit", month: "short", timeZone: "UTC",
  });
}

export function longDate(iso: string): string {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("de-DE", {
    day: "2-digit", month: "long", year: "numeric", timeZone: "UTC",
  });
}

export function monthLabel(key: string): string {
  return new Date(`${key}-01T00:00:00Z`).toLocaleDateString("de-DE", {
    month: "short", year: "2-digit", timeZone: "UTC",
  });
}

export function relativeTime(isoTimestamp: string | null): string {
  if (!isoTimestamp) return "noch nie";
  const minutes = Math.round((Date.now() - new Date(isoTimestamp).getTime()) / 60000);
  if (minutes < 1) return "gerade eben";
  if (minutes < 60) return `vor ${minutes} Minuten`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `vor ${hours} Stunden`;
  return `vor ${Math.round(hours / 24)} Tagen`;
}

export const CATEGORY_LABELS: Record<string, string> = {
  revenue: "Umsatz",
  materialCost: "Fremdleistungen",
  personnel: "Personal",
  rent: "Miete",
  software: "Software",
  insurance: "Versicherungen",
  marketing: "Marketing",
  travel: "Reisen",
  tax: "Steuern",
  financing: "Finanzierung",
  other: "Sonstiges",
};

export const SOURCE_LABELS: Record<string, string> = {
  invoice: "Ausgangsrechnung",
  purchase: "Eingangsrechnung",
  fixedCost: "Fixkosten",
  paymentSchedule: "Zahlungsplan",
  vat: "Umsatzsteuer",
  payroll: "Lohn",
  buffer: "Puffer",
  manual: "Manuell",
};
